<template>
    <div class="page">
        <transition name="fade-transition">
            <v-container v-if="!loading" :class="{'py-3 px-0': phoneOnly, 'py-6': pcOnly}">
                <template v-if="honorPanel && honorPanel.length">
                    <v-row v-if="pcOnly">
                        <v-col v-for="(honorUser, i) in honorPanel" :key="honorUser.id + '-' + i" cols="12" sm="6" md="4" lg="3" xl="2">
                            <v-card class="pa-4 bordered text-center">
                                <div class="details-text muted--text mb-2">#{{ i + 1 }}</div>
                                <v-avatar :size="88" class="mb-1">
                                    <img :src="honorUser.avatar" />
                                </v-avatar>
                                <div style="margin-top: -12px;" class="mb-2">
                                    <v-chip small color="primary" class="font-weight-bold">{{ honorUser.correction_mark }}/{{ honorUser.total_mark }}</v-chip>
                                </div>
                                <div class="medium-text font-weight-bold strong-text--text">{{ honorUser.name }}</div>
                                <div class="details-text text--text">{{ honorUser.governorate }}</div>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-list v-else class="py-0">
                        <template v-for="(honorUser, i) in honorPanel">
                            <v-list-item :key="honorUser.id + '-' + i" class="py-2">
                                <div class="me-3 details-text font-weight-bold muted--text" style="min-width: 28px;">#{{ i + 1 }}</div>
                                <v-list-item-avatar size="56">
                                    <img :src="honorUser.avatar" />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title class="strong-text--text medium-text font-weight-bold">{{ honorUser.name }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ honorUser.governorate }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-chip small color="primary" class="font-weight-bold">{{ honorUser.correction_mark }}/{{ honorUser.total_mark }}</v-chip>
                            </v-list-item>
                            <v-divider v-if="i < honorPanel.length - 1" :key="'divider-' + honorUser.id + '-' + i" inset style="opacity: 0.6"></v-divider>
                        </template>
                    </v-list>
                </template>
                <div v-else class="text-center py-12">
                    <v-icon size="56" color="grey lighten-1" class="mb-3">mdi-trophy-outline</v-icon>
                    <div class="medium-text muted--text">لا يوجد أحد في لوحة الشرف حالياً</div>
                </div>
            </v-container>
        </transition>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: 'HonorPanel',
    data() {
        return {
            honorPanel: null,
            loading: false,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    watch: {
        loading(loading) {
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,
        getHonorPanel() {
            if (!this.loading) {
                this.loading = true;
                this.$store.dispatch('fastGetAction', { url: '/honor-panel' }).then(response => {
                    this.loading = false;
                    this.honorPanel = response.data.honor_panel || [];
                }).catch(() => {
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    mounted() {
        if (this.appData.honor_panel_place === 'separated') {
            this.getHonorPanel();
        } else {
            this.$router.push('/not-found');
        }
    },
};
</script>
